import {USER_NAME} from "@/store/modules/user/constants";

const state = {
    userName : localStorage.getItem(USER_NAME)
}

const getters = {
    userName(state) {
        return state.userName;
    }
}

const mutations = {
    updateUserName(state, newName) {
        state.userName = newName;
        localStorage.setItem(USER_NAME, newName);
    }
}

const actions = {
    updateUserNameFromJwt({commit}, token) {
        const payload = JSON.parse(atob(token.split(".")[1]));
        const name = payload.uid;
        localStorage.setItem(USER_NAME, name);

        commit('updateUserName', name);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}